"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = void 0;
const tslib_1 = require("tslib");
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const styles_1 = require("@mui/material/styles");
exports.StyledButton = (0, styles_1.styled)(Button_1.default, {
    shouldForwardProp: (prop) => prop !== "state",
})(({ theme, state }) => ({
    ...(state === "normal" && {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.disabled,
        ...theme.applyStyles("dark", { backgroundColor: (0, styles_1.alpha)(theme.palette.primary.main, 0.3) }),
        "&:hover": {
            backgroundColor: theme.palette.background.paper,
            boxShadow: "none",
            ...theme.applyStyles("dark", { backgroundColor: (0, styles_1.alpha)(theme.palette.primary.main, 0.3) }),
        },
    }),
    ...(state === "active" && {
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            boxShadow: "none",
        },
    }),
    ...(state === "error" && {
        backgroundColor: theme.palette.error.main,
        ...theme.applyStyles("light", { color: theme.palette.primary.main }),
        "&:hover": {
            backgroundColor: theme.palette.error.main,
            boxShadow: "none",
        },
    }),
}));
exports.default = exports.StyledButton;
